import axios from 'axios';

import { PublicationNewAliasRequest } from '@/module/Author/Publication/model/PublicationTypes';

import { Id, PagedParams, PagedResponse, getData } from '@feature/utils';

import { Chapter, ChapterRequest } from './ChapterTypes';

export function getPaged(params: PagedParams) {
  return axios
    .get<PagedResponse<Chapter>>('/author/chapters/paged', {
      params,
    })
    .then(getData);
}

export function get(id: Id) {
  return axios.get<Chapter>(`/author/chapters/${id}`).then(getData);
}

export function edit(id: Id, request: ChapterRequest) {
  return axios.put<Chapter>(`/author/chapters/${id}`, request).then(getData);
}

export function create(request: ChapterRequest) {
  return axios.post<Chapter>(`/author/chapters`, request).then(getData);
}

export function deleteById(id: Id) {
  return axios.delete<unknown>(`/author/chapters/${id}`).then(getData);
}

export function addNewAlias(chapterId: Id, request: PublicationNewAliasRequest) {
  return axios.put(`/author/chapters/${chapterId}/add-new-alias`, request).then(getData);
}
